<template>
    <div>
        <el-dialog
                :close-on-click-modal="false"
                :title="title"
                :visible.sync="show"
                width="600px" >
            <div style="width: 100%; height: 100%;" v-loading="loading">
                <div class="w100 pl20 pr20 pt20 pb20">
                    <el-form label-width="100px" :model="form" :rules="rules" ref="ruleForm" class="demo-form-inline">
                        <el-form-item label="岗位名称：" prop="postName" >
                            <el-input v-model="form.postName" placeholder="请输入岗位名称"></el-input>
                        </el-form-item>
                        <el-form-item label="所属部门：" prop="belongDeptId" >
                            <TreeSelect size="small"
                                        :data="departmentData"
                                        clearable
                                        v-if="show"
                                        expandAll
                                        ref="deptSingle"
                                        :obj="mapKey"
                                        checkStrictly
                                        @getValue="setDeptSingleMenu">

                            </TreeSelect>
                        </el-form-item>
                        <el-form-item label="管辖部门：" prop="deptList" >
                            <TreeSelect size="small" :data="departmentData"
                                        v-if="show"
                                        clearable
                                        multiple
                                        expandAll
                                        ref="deptDouble"
                                        :obj="mapKey"
                                        checkStrictly
                                        @getValue="setDeptDoubleMenu">
                            </TreeSelect>
                        </el-form-item>
                        <el-form-item label="岗位角色：" prop="roleList" >
                            <el-select v-model="selectRoleList" multiple placeholder="请选择" class="w100">
                                <el-option
                                        v-for="item in roleList"
                                        :key="item.roleId"
                                        :label="item.roleName"
                                        :value="item.roleId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="岗位描述：">
                            <el-input v-model="form.description" type="textarea" placeholder="请输入岗位描述"></el-input>
                        </el-form-item>
                        <el-form-item label="人员：">
                            <el-input
                                    placeholder="请选择成员"
                                    style="width: 345px"
                                    v-model="userText"
                                    disabled
                            ></el-input>
                            <el-button type="primary" style="margin-left:10px"  @click="addUser">+添加</el-button>
                        </el-form-item>

                    </el-form>

                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitForm('ruleForm')" type="primary">确 定</el-button>
                <el-button @click="show = false">取 消</el-button>
            </div>
            <charge-person
                    ref="personModal"
                    :personData="personData"
                    @closePerson="closePerson"
            />
        </el-dialog>

    </div>
</template>

<script>
    import { handleSaveOrUpdate} from '@/api/managementCenter/jobManage';
    import TreeSelect from "@/components/TreeSelect.vue";
    import { getRoleList,getDeptTree} from '@/api/managementCenter/otherApi';
    import  chargePerson from "@/components/management/reportManage/chargePerson.vue";

    export default {
        name: "addJobDialog",
        components: {
            TreeSelect,
            chargePerson
        },
        props: [],
        data() {
            return {
                show: false,
                loading: false,
                title: "",
                type:"",
                selectRoleList:[],
                deptList:[],
                userText:'',
                userId:[],
                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },
                roleList:[],
                departmentData:[],
                form: {
                    postId: "",
                    postName:"",
                    belongDeptId: "",
                    deptList:[],
                    description: "",
                    userList:[],
                    roleList:[],
                },
                rules: {
                    postName: [
                        { required: true, message: "请输入岗位名称", trigger: "blur" }
                    ],
                    belongDeptId: [
                        { required: true, message: "请选择所属部门", trigger: "change" }
                    ],
                    deptList: [
                        { required: true, message: "请选择管辖部门", trigger: "change" }
                    ],
                    roleList: [
                        { required: true, message: "请选择岗位角色", trigger: "change" }
                    ],
                    userList: [
                        { required: true, message: "请选择人员", trigger: "change" }
                    ]
                },
                personData: {
                    userData: [],
                    state: false,
                    disabled: false,
                    data: []
                },
            };
        },
        computed: {

        },
        mounted(){
        },
        methods: {
            //获取部门数据
            getDeptTreeData(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){
                        if(data.data&&data.data.length>0) {
                            if(data.data[0].id==1){
                                this.departmentData = data.data[0].children;
                            }else{
                                this.departmentData = data.data
                            }
                        }
                        if( this.type=='edit'){
                            this.$nextTick(()=>{
                                // 编辑时部门回显
                                this.$refs.deptSingle.setKey(this.form.belongDeptId);
                                this.$refs.deptDouble.setKeys(this.deptList);
                            })
                        }

                    }
                }).catch(err=>{

                })
            },
            setDeptSingleMenu(key,data){//获取子组件值
                this.form.belongDeptId = data.id;
            },
            setDeptDoubleMenu(key,data){//获取子组件值
                this.deptList = (data||[]).map(item=>item.id);
            },
            //获取角色列表
            getRoleListData(){
                getRoleList().then(({data})=>{
                    if(data.code == 0){
                        this.roleList = data.data.map(i=>{
                            return {
                                ...i,
                                roleId:i.roleId+''
                            }
                        })
                    }
                }).catch(err=>{

                })

            },
            //显示人员选择
            addUser() {
                this.$refs.personModal.loadData();
                this.personData.state = true;
            },
            //选择人员
            closePerson(value) {
                if (!value.mans) {
                    this.personData.state = false;
                    return;
                }
                let mans=value.mans||[];
                this.userText= (mans.map(item=>item.name)).join("、");
                this.userId= mans.map(item=>item.userId);
                this.personData.state = false;
                this.personData.data = mans.map(item=>{
                    return{
                        userId: item.userId,
                        name: item.name
                    }
                });
                this.personData.userData = this.userId;
            },

            // 显示弹框
            dialogShow (type,data) {
                this.type=type
                // 重置表单、显示弹框
                this.show = true;
                this.$nextTick(()=>{
                    this.$refs["ruleForm"].resetFields();
                    switch (type) {
                        case 'add' :
                            this.title = "新增岗位"
                            this.form={
                                postId: "",
                                postName:"",
                                belongDeptId: "",
                                deptList:[],
                                description: "",
                                userList:[],
                                roleList:[],
                            };
                            this.selectRoleList=[];
                            this.deptList=[];
                            this.userText="";
                            this.userId=[];
                            break;
                        case 'edit' :
                            this.title = "编辑岗位"
                            this.form={
                                postId: data.postId,
                                postName:data.postName,
                                belongDeptId: data.belongDeptId,
                                deptList:[],
                                description: data.description,
                                userList:[],
                                roleList:[],
                            };
                            this.selectRoleList=(data.roleList||[]).map(i=>i.roleId);
                            this.deptList=(data.deptList||[]).map(i=>i.deptId);
                            this.userText=((data.userList||[]).map(i=>i.username)).join("、");
                            this.userId=(data.userList||[]).map(i=>i.userId);
                            this.personData.data = (data.userList || []).map(i => {
                                return {
                                    userId: i.userId,
                                    name: i.username
                                }
                            });
                            this.personData.userData = this.userId;
                            break;
                    }

                });
            },
            saveOrUpdate(){
                this.loading = true;
                handleSaveOrUpdate(this.form).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.$message.success(  "保存成功!" );
                        this.show=false
                        this.$emit('saveSuccess')

                    }else{
                        this.$message.warning(  data.msg||"保存失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },

            // 确定提交
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.saveOrUpdate()
                    } else {
                        return false;
                    }
                });
            }
        },
        watch: {
            deptList(val){
                this.form.deptList=(val||[]).map(i=>{
                    return {deptId:i};
                })
            },
            selectRoleList(val){
                this.form.roleList=(val||[]).map(i=>{
                    return {roleId:i};
                })
            },
            userId(val){
                this.form.userList=(val||[]).map(i=>{
                    return {userId:i};
                })
            },
            show(value){
                if(value){
                    // 打开弹框时，获取岗位和角色数据
                    this.getDeptTreeData()
                    this.getRoleListData()
                }else{
                    this.personData.data = [];
                    this.personData.userData = [];

                }
            }
        },
        filters: {}
    };
</script>

<style scoped lang="less">


</style>
